<template>
    <div>
        <div class="ZMSeparatoreScheda" 
            style="font-weight: bold;clear:both;padding-bottom: 2px;margin-bottom: 5px;background-color:#2596be;display: flex;width: 95.5%;float: right;margin-right: 10px;">
            Versione software
        </div>
        <div style="display: flex;width: 95.5%;float: right;margin-right: 10px;flex-direction: column;">

        <!-- copiare questo div -->

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.16.97</b>
          </div>
          <div class="col-md-3">
              05 Maggio 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Corretta gestione dati per OldData</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.16.96</b>
          </div>
          <div class="col-md-3">
              28 Aprile 2026 - Alessio Verardo, Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Alessio Verardo</strong>
            <p>FIX: Corretto bug che non mostrava i valori delle Y nel popup d'impostazione dell'asse Y per i grafici storici delle Velocità e delle Accelerazioni</p>
            <p>FIX: Corretto bug che non mostrava la label sull'asse X della prima data nei grafici di assorbimento e tensione</p>
            <p>FIX: Corretto errore nei moduli mostrati quando venivano ricaricati i dati della tensione e dell'assorbimento</p>
            <strong>Francesco Ardini</strong>
            <p>CHG: Modificata la gestione degli allarmi</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.16.95</b>
          </div>
          <div class="col-md-3">
              28 Aprile 2026 - Dario Scianna, Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>CHG: Ora il menù nei modulabili non mostra più "Modifiche grafiche" ed "Spost. Differenziale"/"Spost. Cumulativo" nel caso di catene con solo piezometri</p>
            <p>FIX: Fix per stampa con più grafici con stesso modulo</p>
            <strong>Alessio Verardo</strong>
            <p>FIX: Fix vari ai grafici storici nei modulabili</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.16.94</b>
          </div>
          <div class="col-md-3">
              27 Aprile 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Fixati i piezometri nella pagina dei grafici modulabili</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.16.93</b>
          </div>
          <div class="col-md-3">
              27 Aprile 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Corretto l'adatta dei campioni rilevati</p>
            <p>FIX: Corretta label del PDF dei campioni rilevati, i numeri con la virgola venivano interpretati male</p>
            <p>FIX: Aggiornata label dei piezometri dei campioni rilevati</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.16.92</b>
          </div>
          <div class="col-md-3">
              24 Aprile 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Corretto arrotondamento dei decimali degli allarmi</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.16.91</b>
          </div>
          <div class="col-md-3">
              24 Aprile 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>CHG: Ora è visibile l'hint per i piezometri dei packer anche se sono secchi</p>
            <p>FIX: Corretto calcolo profondità nel dettaglio dei packer</p>
            <p>FIX: Adesso la tabella ingrandita dei packer mostra la profondità dei piezometri secchi, non più il trattino</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.16.90</b>
          </div>
          <div class="col-md-3">
              23 Aprile 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Tolta la doppia data nel report della prima pagina dei PDF</p>
            <p>FIX: Corretta la gestione delle date di calibrazione ed installazione per quando sono null</p>
            <p>FIX: Impostato 8 come default la pressione secco e corretta udm nella tabella della dashboard</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.16.89</b>
          </div>
          <div class="col-md-3">
              23 Aprile 2026 - Dario Scianna, Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Ora i piezometri mostrano 2 decimali anche se l'ultimo è uno 0</p>
            <p>FIX: Fixato caricamento del modello default</p>
            <strong>Francesco Ardini</strong>
            <p>FIX: Sistemai i grafici di frequenza accelerometrici</p>
            <p>FIX: Adesso la temperatura viene allineata correttamente negli orizzontali</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.16.88</b>
          </div>
          <div class="col-md-3">
              22 Aprile 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>NEW: Aggiunta gestione per i piezometri secchi che non mostrano la colonna d'acqua</p>
            <p>CHG: Adesso se una catena non ha inclinometri, non viene più mostrato il polare in dashboard</p>
            <p>FIX: Adesso se non sono presenti dati, i grafici dei campioni rilevati vengono comunuqe disegnati</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.16.87</b>
          </div>
          <div class="col-md-3">
              22 Aprile 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Adesso i polari con interpolazione in dashboard mostra correttamente l'interpolazione</p>
            <p>FIX: Adesso il tasto ricarca dei grafici storici funziona correttamente</p>
            <p>FIX: Aggiunta la label "n.eventi" per il grafico delle frequenze accelerometriche</p>
            <p>FIX: L'udm delle X del grafico delle frequenze accelerometriche ora è fisso ad un giorno</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.15.86</b>
          </div>
          <div class="col-md-3">
              21 Aprile 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Corretto il calcolo dell'udm dell' ampiezza XYZ per modulo</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.15.85</b>
          </div>
          <div class="col-md-3">
              21 Aprile 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>NEW: Aggiunta la gestione della quota del piezometro</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.14.84</b>
          </div>
          <div class="col-md-3">
              20 Aprile 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>CHG: Modificata la gestione dei bottoni dei Grafici abbinati per la visualizzazione mobile</p>
            <p>CHG: Cambiata la dimensione dei bottoni del riallineamento alla data</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.14.83</b>
          </div>
          <div class="col-md-3">
              17 Aprile 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>NEW: Aggiunta la gestione della pressione secca</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.13.82</b>
          </div>
          <div class="col-md-3">
              16 Aprile 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Ora salta correttamente gli intervalli nei campioni rilevati in cui mancano dati</p>
            <p>FIX: Ora si vede il primo markup dei campioni rilevati</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.13.81</b>
          </div>
          <div class="col-md-3">
              16 Aprile 2026 - Dario Scianna, Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>NEW: Introdotto nel menù laterale delle ampiezza per eventi accelerometrici la voce "Soglie rilevamento" con "Mostra" e "Nascondi" che permette di modificarla in tutti i grafici</p>
            <p>CHG: Adesso nei campioni rilevati, nei punti in cui non sono presenti dati, il grafico non viene più disegnato</p>
            <p>FIX: Non vengono più mostrati i markup dei punti senza dati</p>
            <p>FIX: Corretta la formattazione della label della cronologia eventi accelerometrici</p>
            <p>FIX: Corretta udm della label della stazione meteo</p>
            <p>FIX: Aggiornate le tabelle dei moduli dei popup per l'esportazione degli storici come xlsx</p>
            <strong>Alessio Verardo</strong>
            <p>NEW: Inserite nella stampa PDF dei grafici accelerometrici dettaglio ampiezza le legende per le Soglie SMS1, SMS2, SMS3, SMS4 e le Soglie di Rilevamento e le Soglie di allarme</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.12.80</b>
          </div>
          <div class="col-md-3">
              15 Aprile 2026 - Dario Scianna, Alessio Verardo, Andrea Capozza, Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Corretto il proporzionamento dei grafici, adesso le udm e gli assi sono proporzionati ai dati</p>
            <strong>Alessio Verardo</strong>
            <p>FIX: Rimosso l'input per inserire l'ora d'installazione nelle modifiche dei dati generali di una catena</p>
            <p>NEW: Inserite le soglie SMS anche nelle stampe</p>
            <p>FIX: Fatti sparire i tastini della configurazione dei SMS dai grafici accelerometrici di frequenza</p>
            <p>FIX: Risolto problema caricamento dei grafici storici</p>
            <p>FIX: Diminuita la dimensione della checkbox per settare una banda nascosta nel menu di configurazione di una banda</p>
            <p>FIX: Correzione della traduzione del titolo del popup Configura sommario nel menu della Modifica di un modello </p>
            <strong>Andrea Capozza</strong>
            <p>FIX: Risolti problemi di visualizzazione degli storici delle frequenze per modulo dei dati accelerometrici</p>
            <strong>Francesco Ardini</strong>
            <p>FIX: Fixata la gestione dei millesimi nell'esportazione</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.12.79</b>
          </div>
          <div class="col-md-3">
              03 Aprile 2026 - Alessio Verardo, Francesco Ardini, Andrea Capozza
          </div>
          <div class="col-md-6">
            <strong>Alessio Verardo</strong>
            <p>FIX: Risolto bug di visualizzazione dei righelli globali nei grafici accelerometrici di ampiezza e frequenza nel PDF</p>
            <p>NEW: Adesso è possibile nascondere le bande nella dashboard di un sito</p>
            <strong>Francesco Ardini</strong>
            <p>NEW: Aggiunta esportazione di pdf e xlsx di tutti i grafici per i superamenti soglie</p>
            <p>NEW: Aggiunta modifica generale scale di tutti i grafici per i superamenti soglie</p>
            <p>FIX: Sistemati grafici eventi accelerometrici superamenti soglie</p>
            <p>FIX: Sistemata stampa PDF grafici eventi accelerometrici superamenti soglie</p>
            <p>FIX: Sistemato file excel sintesi eventi accelerometrici superamenti soglie</p>
            <p>FIX: Risolti problemi legati alla selezione degli eventi accelerometrici superamenti soglie</p>
            <p>FIX: Risolti problemi grafici sinottico eventi accelerometrici superamenti soglie</p>
            <strong>Andrea Capozza</strong>
            <p>NEW: Nel dettaglio ampiezza dello storico dei dati accelerometrici sono state implementate le soglie SMS, Rilevamento e Allarme</p>
            <p>FIX: Nello storico delle stazioni meteo adesso le labels nel non si sovrapporranno con le linee</p>
            <p>FIX: Nello storico delle stazioni meteo la precipitazione oraria/ultima 10m non appaiono più in un formato sbagliato</p>
            <p>FIX: Nello storico delle stazioni meteo le precipitazioni ultimi 10m non vengono più coperti dagli altri istogrammi</p>
            <p>FIX: Nello storico delle stazioni meteo risolti malfunzionamenti legati al non selezionare alcun asse</p>
            <p>FIX: Nello storico delle stazioni meteo dopo aver cambiato i colori ai vari assi si avranno i nuovi anche nel pdf</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.11.78</b>
          </div>
          <div class="col-md-3">
              18 Marzo 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Adesso i grafici di ampieza accelerometrica mostrano correttamente anche il primo dato che prima non veniva mostrato</p>
            <strong>Alessio Verardo</strong>
            <p>FIX: Adesso i righelli inseriti nei grafici nel dettaglio frequenza modulo dei dati accelerometrici vengono disegnati al di sopra delle frequenze</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.11.77</b>
          </div>
          <div class="col-md-3">
              18 Marzo 2026 - Dario Scianna, Alessio Verardo, Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>NEW: Aggiunti i pulsanti laterali Scale asse X, Scale asse Y, Modifica Colori, Aggiungi e rimuovi Righelli ai grafici di ampiezza e frequenza del superamento soglie</p>
            <p>CHG: Spostata la voce degli spostamenti Differenziali/Cumulativi nel menù come un'opzione unica fuori dal gruppo</p>
            <p>FIX: Risolto problema di caricamento sinottico</p>
            <p>FIX: Aggiornando la pagina adesso rimangono le voci del menù laterale e non scompaiono più</p>
            <p>FIX: Modificata label della tabella per i piezometri standard medi</p>
            <p>FIX: Corretto l'ordine della legenda dei PDF dei grafici di ampiezza superamento soglia</p>
            <strong>Alessio Verardo</strong>
            <p>FIX: Ridotta dimensione del popup del tasto cambia nei sinottici dei grafici superamento soglie</p>
            <p>FIX: Inserito nel titolo dei dei grafici superamento soglie il valore dei millisecondi</p>
            <p>FIX: Risolto problema scorrimento pagina nei sinottici dei grafici superamento soglie</p>
            <p>FIX: Risolto il problema del ridisegnamento degli allarmi nei grafici di velocità giornaliera</p>
            <p>FIX: Se vengono cambiate le impostazioni degli assi dei grafici, i cambiamenti rimangono anche nel Dettaglio del grafico</p>
            <strong>Francesco Ardini</strong>
            <p>FIX: Corretti alcuni valori delle tabelle ingrandite che risultavano NaN</p>
            <p>FIX: Corretta la label del cambio di visualizzazione del cumulativo degli orizzontali</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.11.76</b>
          </div>
          <div class="col-md-3">
              16 Marzo 2026 - Dario Scianna, Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>NEW: Inserita una nuova configuarazione per poter mostrare i moduli utilizzati per la media per la media dei piezometri standard</p>
            <p>CHG: Ora la tabella dei piezometri standard mostra solo il modulo selezionato</p>
            <p>FIX: Gli hint dei grafici attuali adesso vengono visualizzati correttamente</p>
            <p>FIX: Aggiornata label popup cronologia eventi</p>
            <strong>Francesco Ardini</strong>
            <p>CHG: Ora i moduli di deformazione che non hanno estensimetro vengono visualizzati a 0</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.11.75</b>
          </div>
          <div class="col-md-3">
              13 Marzo 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Impostato il colore #fff per le righe separatrici dei modulabili</p>
            <p>FIX: Ripristinati spazi bianchi tra i moduli degli attuali</p>
            <p>FIX: Ora mostra correttamente l'udm dell'allarme</p>
            <p>FIX: Ora mette autoscale quando viene caricato un .cew</p>
            <p>FIX: Alla modifica del menù della catena adesso non imposta più il colore del placeholdr a nero (null)</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.11.74</b>
          </div>
          <div class="col-md-3">
              11 Marzo 2026 - Dario Scianna, Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>CHG: La label dei dati rifetiri nel dettaglio ingrandito dei grafici attuali adesso è fuori dalla tabella</p>
            <p>CHG: Il popup della stazione meteo adesso è come gli altri popup</p>
            <p>CHG: Il grafico della lista superamenti soglia adesso è blu</p>
            <p>CHG: La falda dei piezometri non sborda più il grafico e viene rappresentata in quota 0 la misura nel caso in cui questa sia sopra il livello del piano campagna</p>
            <p>FIX: Aggiornata la label dei campioni rilevati inserendo '-' allineandola all'EW</p>
            <p>FIX: Adesso non mescola più i dati nella stampa PDF dei piezometri mentre degli abbinati sono presenti</p>
            <p>FIX: Adesso è visibile il notch dello 0 nei piezometri</p>
            <p>FIX: Gli sotrici degli xlsx adesso hanno la data formattata correttamente</p>
            <p>FIX: Allineato con '(null)' la mancanza dei dati negli xlsx dei grafici storici giornalieri</p>
            <p>FIX: Nella stampa dei piezometri, adesso i calori sono sempre a due cifre decimali, prima in alcune che avevano lo "0" non veniva rappresentato</p>
            <strong>Francesco Ardini</strong>
            <p>CHG: Ora sotto i grafici di velocità giornaliera non c'è più tanto spazio bianco vuoto inutile</p>
            <p>FIX: Allineati PDF dei grafici attuali orizzontali</p>
            <p>FIX: Ora funziona nuovamente l'allineamento dei campioni rilevati</p>
            <p>FIX: Ora funzionano nuovamente i grafici storici con assenza di dati</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.11.73</b>
          </div>
          <div class="col-md-3">
              11 Marzo 2026 - Dario Scianna, Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Nei grafici orizzontali adesso tutte le righe di intestazione sono correttamente in grassetto</p>
            <strong>Francesco Ardini</strong>
            <p>FIX: Adesso la lavel di allineamento nella dashboard non da gli eventi del mouse</p>
            <p>FIX: Fix adattamento automatico</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.11.72</b>
          </div>
          <div class="col-md-3">
              10 Marzo 2026 - Dario Scianna, Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Nella tabella dei grafici ingranditi è stata spostata la scritta "Dati riferiti al: ..." a sinistra invece che a destra</p>
            <p>FIX: Nella tabella dei grafici ingranditi l'intestazione della tabella che prima era allineata a sinistra ed i dati che prima erano allineati a destra sono stati centrati orizzontalmente</p>
            <p>FIX: Diminuita la larghezza della colonna ID nella tabella dei grafici ingranditi</p>
            <p>FIX: Corretto il piezometro di AKN0011</p>
            <p>FIX: Ridotta la dimensione della label di "Riallineamento alla data" nei grafici attuali</p>
            <p>FIX: Ora i piezometri mostrano nuovamente gli abbinati nell'ingrandito</p>
            <p>FIX: Adesso le linee di separazione dei moduli della prima banda toccano la seconda banda e la parte in alto nel titolo rimane bianca in modod da separare</p>
            <p>FIX: Quando si toglie la visualizzazione del piezomerto attuale dall'ingrandito e si torna ai grafici non ingranditi, adesso non scompare più il grafico attuale</p>
            <p>FIX: Adesso all'apertura del progetto, i grafici polari sono tutti con la stessa scala di default, cioè viene usato come valore di default la massima scala tra le varie colonne</p>
            <p>FIX: Il simbolo di CSG del legalfooter della pagina dei grafici modulabili adesso non viene più coperto dai grafici</p>
            <strong>Francesco Ardini</strong>
            <p>FIX: Adesso viene lasciato uno spazio vuoto nel caso non siano presenti dati registrati</p>
            <p>FIX: Sistemati grafici estensimetrici orizzontali: adesso il grafico non viene disegnato sullo 0 se non sono presenti dati</p>
            <p>FIX: Sistemata la visualizzazione delle label dei markup per il dettaglio dei grafici</p>
            <p>FIX: Risolto problema visualizzazione grafici attuali</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.11.71</b>
          </div>
          <div class="col-md-3">
              06 Marzo 2026 - Dario Scianna, Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>NEW: Aggiunto popup per l'xlsx dei grafici attuali per poter inserire ID Report, Nome operatore e Testo</p>
            <p>NEW: Aggiunto popup di conferma per il cambio del modello di default</p>
            <p>FIX: Risolto bug per il quale scomparivano i markup della deformazione allineata in presenza degli abbinati</p>
            <p>FIX: Risolto bug che faceva apparire il notch del PDF del piezometro di colore azzurro se fatto durante lo zoom</p>
            <p>FIX: Adesso non compaiono più senza motivo alcuni 1 nel notch del grafico del piezometro</p>
            <p>FIX: Adesso viene rappresentata correttamente anche l'ultima quota del notch nel PDF del piezometro</p>
            <p>FIX: Allineato font e dimensione testo della label ricarica dati del modifica profilo</p>
            <p>FIX: Il PDF del polare ora disegna correttamente anche il cerchio esterno se tocca il grafico</p>
            <p>FIX: Quando non sono presenti grafici visibili negli attuali, adesso il piezometro mostra correttamente il grafico vuoto</p>
            <p>FIX: Ora la visibilità dei piezometri è gestita correttamente con gli abbinati</p>
            <p>FIX: Sistemata la visualizzazione dei markup quando non sono presenti grafici</p>
            <p>FIX: Adesso se non trova campioni per per allineare ad una data, compare un popup come per gli abbinati</p>
            <p>FIX: Adesso nel dettaglio dell'azimut, se questo ha un filtro, viene correttamente visualizzato</p>
            <p>FIX: Corretti gli errori sui dati delle tabelle dei grafici ingranditi</p>
            <p>FIX: Corretta udm con °C nella tabella del PDF della temperatura</p>
            <p>FIX: Corretta udm della temperatura nei grafici orizzontali</p>
            <p>FIX: Adesso nel PDF degli attuali di AKN0011 si vedono tutti i dati nella tabella, prima alcuni non ci stavano</p>
            <p>FIX: Nel PDF dei grafici attuali verticali ora i dati non sono più in grassetto</p>
            <p>FIX: Corretta l'altezza della prima riga delle tabelle dei grafici ingranditi</p>
            <p>FIX: Adesso è nuovamnete presenta la colonna Azimut negli xlsx dei grafici attuali</p>
            <p>FIX: Corretto il dimensionamento delle colonne degli xlsx dei grafici attuali ed i nomi delle colonne sono stati allineati all'EW</p>
            <p>FIX: Adesso i dati degli xlsx dei grafici attuali sono ordinati come nell'EW ed inoltre sono arrotondati come nell'EW</p>
            <p>FIX: Aggiunte le righe di intestazione del committente e del sito nell'xls dei grafici attuali</p>
            <p>FIX: Le dimensioni delle colonne degli xlsx dei campioni rilevati storici sono state migliorate</p>
            <p>FIX: Fixati i dati degli estensimetri e dei piezometri che riportavano il valore 0 quando doveva essere null negli xlsx dei campioni storici</p>
            <p>FIX: Adesso la generazione dell'xlsx di spostamento, velocità ed accelerazione funziona nuovamente</p>
            <strong>Francesco Ardini</strong>
            <p>NEW: Adesso mantiene i dati dell'allineamento alla data in memoria quando si passa dagli attuali agli storici</p>
            <p>FIX: Sistemata esportazione xlsx grafici storici</p>
            <p>FIX: Sistemata altezza grafico verticale</p>
            <p>FIX: Corretto overlay dei grafici attuali che allargava il grafico</p>
            <p>FIX: Non taglia più le label con la descrizione dei markup e non fa spuntare la barra di scorrimento sul grafico</p>
            <p>FIX: Sistemati problemi su stazione meteo</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.11.70</b>
          </div>
          <div class="col-md-3">
              03 Marzo 2026 - Dario Scianna, Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>NEW: Aggiunta colonna per la pressione nel pdf del piezometro</p>
            <p>NEW: Aggiunte linee di delineazione per la banda superiore</p>
            <p>NEW: Aggiunte l'unità di misura l'ora e la data nella tabella degli allarmi</p>
            <p>NEW: Aggiunta la riga di intestazione nei grafici orizzontali "Dati rifetiti a ..."</p>
            <p>NEW: La data di allineamento nell'intestazione del PDF è stata aggiunta nei grafici orizzontali</p>
            <p>CHG: Cambiato l'algoritmo del camcolo dei notch</p>
            <p>CHG: Nei PDF dei grafici orizzontali, adesso la temperature è tratteggiata</p>
            <p>CHG: Adesso la tabella dei grafici orizzontali si adatta al numero di dati</p>
            <p>FIX: Corretti i colori delle temperature abbinate nei grafici orizzontali</p>
            <p>FIX: Corretta la label del titolo tabella delle deformazioni dei grafici orizzontali</p>
            <p>FIX: Corretto il disegno dei markup dei grafici orizzontali</p>
            <p>FIX: Il bordo inferiore del grafico del piezometro adesso è allineato in spessore agli altri lati del grafico</p>
            <p>FIX: Adesso dispone correttamente la checkbox dell' adattamento automatico dimensioni nelle modifiche grafiche catene</p>
            <p>FIX: Adesso le falde sopra lo zero vengono disegnate correttamente nei PDF dei piezometri</p>
            <p>FIX: Corretto il calcolo dei notch dei piezometri nei pdf, adesso parte dall'alto invece che dal basso a disegnare</p>
            <p>FIX: I grafici orizzontali non hanno più la barra di scorrimento e sono stati posizionati correttamente</p>
            <p>FIX: Il grafico di temperatura longitudinale mostra l'intervallo di temperature corretto</p>
            <p>FIX: Bloccato lo zoom della temperatura orizzontale</p>
            <p>FIX: Corretto il notch dei grafici orizzontali</p>
            <p>FIX: Ora il mese della data di allineamento è scritto per esteso nelle stampe dei PDF dei grafici orizzontali</p>
            <p>FIX: Ora funzionano nuovamente le stampe dei grafici orizzontali</p>
            <p>FIX: Corretti Notch, Label delle ordinate, Report, terzo asse ed aggiunta la label del cliente nelle stampe PDF dei grafici orizzontali</p>
            <p>FIX: Corretta la posizione del label della temperatura nei grafici orizzontali</p>
            <p>FIX: Adesso la prima riga delle tabelle dei grafici non è più arancione arancione</p>
            <p>FIX: Corretto bug che raddoppiava la label della temperatura nei grafici orizzontali</p>
            <p>FIX: Nei grafici storici adesso l'estensimetro in legenda è del colore a lui corrispondente nel grafico</p>
            <p>FIX: Corretta l'asse Y dei grafici di deformazione orizzontale allineata</p>
            <p>FIX: Aggiornate le label "allineamento assi" con "modifica impostazioni assi" ed "ampiezza" con "unità principale"</p>
            <p>FIX: Ripristinata la possibilità di cambiare il tipo di cumulazione nei grafici orizzontali</p>
            <p>FIX: Corretti i decimali nelle tabelle dei PDF degli orizzontali</p>
            <p>FIX: Uniformata la grandezza dei fonti dei grafici degli spostamenti sovrapposti, dettaglio frequenza eventi accelerometrici per modulo, lista superamento soglia, cronologia eventi, tensione ed assorbimento con quelli degli spostamenti</p>
            <p>DEL: Rimossa la possibilità di ingrandire i grafici orizzontali come in EW</p>
            <strong>Francesco Ardini</strong>
            <p>NEW: Adesso mantiene i dati degli abbinati in memoria quando si passa dai grafici attuali agli storici</p>
            <p>CHG: Separata la modifica degli assi, invece di modificarli per tutte le tipologie di campioni rilevati, ora è possibile modificare singolarmente piezometri, estensimetri e inclinometri</p>
            <p>FIX: Risolto problema adattamento grafici piezometri ed estensimetri nei campioni rilevati</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.10.69</b>
          </div>
          <div class="col-md-3">
              16 Febbraio 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Sono stati corretti i notch dei piezometri che in alcuni casi non partivano da 0</p>
            <p>FIX: Corretto il disegno della colonna dei piezometriche non viene più raffigurato quando ingrandisco</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.10.68</b>
          </div>
          <div class="col-md-3">
              29 Gennaio 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Quando si ingrandiscono i piezometri, se sono presenti valori oltre lo zero, vengono visualizzate e le righe che arrivavano all'altezza reale con numeri positivi</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.10.67</b>
          </div>
          <div class="col-md-3">
              29 Gennaio 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Adesso quando ingrandisco i piezometri, se sono presenti valori oltre lo zero, non vengono più visualizzati e le righe arrivavano all'altezza reale</p>
            <p>FIX: I dati del mpc nella tabella del dettaglio dei piezometri adesso mostra il segno corretto</p>
            <p>FIX: Corretto il baco che nei piezomerti con la media, mostrava erroneamente tutti i piezometri</p>
            <p>FIX: Corretta la stampa dei piezometri con la media</p>
            <p>FIX: Adesso il puntatore del mouse diventa un puntatore quando passi sopra al menù</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.10.66</b>
          </div>
          <div class="col-md-3">
              26 Gennaio 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Adesso nella schermata di login, la lingua è visualizzata in base all'ultimo account loggato</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.10.65</b>
          </div>
          <div class="col-md-3">
              26 Gennaio 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Corretta la dimensione della pagina nel superamento soglia, che faceva comparire a lato una barra come se si potesse scorrere la pagina</p>
            <p>FIX: Ora non compare più una doppia barra di scorrimento quando si caricano più grafici del superamento soglia</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.10.64</b>
          </div>
          <div class="col-md-3">
              26 Gennaio 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: La stampa dei PDF dei grafici di superamento soglia, adesso visualizza correttamente solo il grafico del modulo selezionato e non tutti i grafici di quel modulo</p>
            <p>FIX: Corretto il camcolo dei millisecondi stampati nella label della stampa PSD dei grafici del superamento soglia</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.10.63</b>
          </div>
          <div class="col-md-3">
              23 Gennaio 2026 - Dario Scianna, Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Il grafico di deformazione ora inizia forzatamente da 0 anche se sono presenti moduli con profondità negative, come gli altri attuali</p>
            <p>FIX: Rimossa la profondità massima nei grafici attuali introdotta nella versione 1.10.62</p>
            <p>FIX: La tabella delle temperature adesso mostra sempre 2 cifre nelle tabelle</p>
            <strong>Alessio Verardo</strong>
            <p>FIX: Corretto il calcolo del notch dei grafici attuali nelle stampe PDF</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.10.62</b>
          </div>
          <div class="col-md-3">
              23 Gennaio 2026 - Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Alessio Verardo</strong>
            <p>FIX: Adesso nei grafici delle Velocità Giornaliere la spunta per le soglie di allarme è automaticamente attivata</p>
            <p>FIX: Sono stati rimossi i valori decimali dei numeri sull'asse Y dei grafici della Cronologia eventi accelerometrici mantenendo solo la parte intera</p>
            <p>FIX: Adesso viene mostrata la profondità massima nei grafici attuali</p>
            <p>FIX: Risolto il problema per sui i piezometri abbinati non si vedevano correttamente nell'ingrandito</p>
            <p>FIX: Cambiate le label delle legende per le stampe dei grafici delle accelerazioni e delle velocità giornaliere e orarie. Adesso in base al tipo di grafico la label indica se è giornaliero o l'orario</p>
          </div>
          <br>
        </div> 
        
        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.10.61</b>
          </div>
          <div class="col-md-3">
              20 Gennaio 2026 - Dario Scianna, Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Alessio Verardo</strong> 
            <p>FIX: Aggiunta la label "Legenda" nelle stampe degli spostamenti sovrapposti</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.10.60</b>
          </div>
          <div class="col-md-3">
              20 Gennaio 2026 - Dario Scianna, Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Alessio Verardo</strong> 
            <p>FIX: Adesso le labed dei grafici storici sono allineate all'EW</p>
            <strong>Dario Scianna</strong> 
            <p>FIX: Le date nella label del superamento soglia adesso è visualizzata nella formattazione corretta</p>
            <p>FIX: Corretta la formattazione delle date nei PDF</p>
            <p>FIX: Aggiornato titolo degli spostamenti allineandolo all'EW</p>
            <p>FIX: Aggiornata scritta legenda stampe spostamenti sovrapposti</p>
            <p>FIX: Aggiornato Titolo stampe spostamenti sovrapposti e separati</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.10.59</b>
          </div>
          <div class="col-md-3">
              20 Gennaio 2026 - Dario Scianna, Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Alessio Verardo</strong> 
            <p>FIX: Adesso nei grafici delle velocità e accelerazioni giornaliere e nei PDF le label sull'asse X partono dalle 12:00</p>
            <p>FIX: Risolto bug dell'undefined dei minimi e massimi adattamenti dell'asse Y per Velocità, Accelerazioni e Spostamenti</p>
            <p>FIX: Ora è visibile la label del Tempo [ms] nei grafici del Superamento soglia sull'asse X </p>
            <strong>Dario Scianna</strong> 
            <p>FIX: Adesso vengono correttamente visualizzate le scritte delle label X ed Y nei PDF dei grafici di superamento soglia</p>
            <p>FIX: Corrette le label dei PDF dei grafici di superamento soglia</p>
            <p>FIX: Adesso l'ultimo dato viene visualizzato correttamente nel totale degli spostamenti</p>
            <p>FIX: Corretto il disegno dei segmenti di velocità nel grafico dei totali nel PDF, quando non erano presenti tutti i punti dell'intervallo delle date l'ultimo segmento era errato</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.10.58</b>
          </div>
          <div class="col-md-3">
              19 Gennaio 2026 - Dario Scianna, Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Alessio Verardo</strong> 
            <p>FIX: I grafici del superamento soglia adesso sono ordinati in maniera crescente per Modulo e Data</p>
            <p>FIX: Ora nell'esportazione PDF nei Campioni Rilevati vengono stampati tutti i grafici, prima non stampava piezometri ed estensimetri</p>
            <strong>Dario Scianna</strong> 
            <p>FIX: Allineata label della profondità del modulo dei PDF dei grafici di ampiezza giornaliera con quella dell'EW</p>
            <p>FIX: La label della profondità e dell'asse Y dei PDF dei grafici di frequenza giornaliera degli eventi accelerometrici è stata allineata all'EW</p>
            <p>FIX: I grafici della frequenza e dell'ampiezza giornaliera degli eventi accelerometrici adesso mostrano correttamente la profondità del sensore</p>
            <p>FIX: Adesso la stampa dei PDF dei grafici di frequenza ed ampiezza degli eventi accelerometrici che non hanno dati, ritorna correttamente un grafico vuoto invece di spazio bianco</p>
            <p>FIX: Corretta la stampa dei segmenti di velocità del totale degli spostamenti</p>
            <p>FIX: Quando faccio un PDF che ha sia segmenti di velocità che falde, adesso disegna entrambi</p>
            <p>FIX: Le soglie di allarme non spariscono più dal grafico quando si aggiunge una falda</p>
            <p>FIX: Nei grafici storici dello spostamento, nei moduli vengono disegnati correttamente sia i segmenti di velocità che le falde</p>
            <p>FIX: Quando si esportano tutti i grafici negli storici, vengono stampati tutti, mentre prima stampavo solo i grafici visibili nella pagina</p>
            <p>FIX: Corretti gli intervalli di tempo dei grafici storici</p>
            <p>FIX: Adesso i grafici dei piezometri e degli estensimetri mostrano solo la profondità di coda come su EW</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.10.57</b>
          </div>
          <div class="col-md-3">
              14 Gennaio 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong> 
            <p>FIX: Corretto il calcolo della grandezza delle righe delle tabelle nella stampa dei grafici attuali del PDF</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.10.56</b>
          </div>
          <div class="col-md-3">
              14 Gennaio 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong> 
            <p>NEW: Introdotto popup per le stampe degli attuali che permette di stampare dia il gradico differenziale che quello cumulativo, la prima pagina con nome operatore e testo e numero rapporto</p>
            <p>NEW: Introdotto il nome per i clienti, inoltre viene automaticamente importato dai file .cew</p>
            <p>CHG: Adesso i markup non vengono più visualizzati se i punti del grafico si trovano fuori dai margini</p>
            <p>CHG: Ridotto il numero delle righe delle tabelle a destra dei grafici a 70, in modo da concedere più spazio ai numeri</p>
            <p>CHG: Adesso, nei grafici attuali, gli hint dei punti che si trovano oltre la metà destra del grafico appaiono spostati a sinistra, in modo che non vengano più tagliati</p>
            <p>FIX: Nelle tabelle delle stampe dei PDF dei grafici attuali è stato aggiornato il titolo della colonna "Profondita' sensore" con "Profondita' [m]"</p>
            <p>FIX: Nella tabella dei piezometri del grafico ingrandito è stato aggiornato il titolo della colonna "Profondita' sensore" con "Profondita' [m]"</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.10.55</b>
          </div>
          <div class="col-md-3">
              09 Gennaio 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>NEW: Adesso vengono disegnati i segmenti di velocità nei PDF</p>
            <p>NEW: Adesso possono essere stampati i PDF dei piezometri e degli estensimetri nei campioni rilevati, mentre prima stampava sempre il grafico degli inclinometri a prescindere</p>
            <p>NEW: Creata una costante per modificare il font dei grafici di tutte le stampe PDF</p>
            <p>NEW: Adesso le falde vengono stampate nei PDF delle accelerazioni, delle accelerazioni e nei rispettivi totali</p>
            <p>NEW: Aggiunte le soglie di allarme alla stampa del PDF quando visibili nei grafici di velocità giornaliera</p>
            <p>NEW: Aggiunta la label della direzione di riferimento nei grafici di spostamento sovrapposto</p>
            <p>CHG: Adesso la stampa del PDF del grafico piezometro mostra solo l'attuale</p>
            <p>FIX: Quando facio il PDF dei campioni rilevati senza Pitch, Roll o temperatura, adesso vengono rimosse correttamente dal grafico</p>
            <p>FIX: Corrette le assi dei notch che venivano disegnare come linee continue nelle stampe PDF dei grafici attuali</p>
            <p>FIX: Rimosso il grassetto nell'intestazione e nei titoli nelle stampe PDF dei grafici attuali</p>
            <p>FIX: Dato più spazio alle tabelle nelle stampe PDF dei grafici attuali</p>
            <p>FIX: Arrotondati ad un decimale le cifre della temperatura (prima a volte era un decimale ed a volte senza) nelle stampe PDF dei grafici attuali</p>
            <p>FIX: Nelle stampe PDF dei grafici attuali adesso non appare più erroneamente il - che divide il titolo del grafico dal tipo per i grafici senza tipo</p>
            <p>FIX: Aggiornato il nome grafico e titolo del grafico nella stampa del PDF della deformazione</p>
            <p>FIX: Adesso gli anelli del polare spariscono quando incontrano il bordo del grafico</p>
            <p>FIX: Adesso gli spostamenti dei grafici polari non vengono più disegnati fuori dal grafico</p>
            <p>FIX: Adesso le linee degli assi del PDF dei piezometri sono tratteggiate</p>
            <p>FIX: Nella stampa del PDF del packer non vengono più visualizzate le unità di misura che sbordano il grafico</p>
            <p>FIX: Nella grafico dei packer degli attuali non vengono più visualizzate le unità di misura che sbordano il grafico</p>
            <p>FIX: Corretta la divisione del notch del grafico di deformazione</p>
            <p>FIX: Nel PDF dei piezometri adesso vengono mostrati solo i dati degli attuali come negli altri grafici</p>
            <p>FIX: Adesso nel PDF dei piezometri, quando è presente più di una colonna, allora il colore della prima colonna viene colorato di grigio, coerentemente alla grafica web</p>
            <p>FIX: I grafici dei piezometri con la media adesso funzionano nuovamente</p>
            <p>FIX: Aggiornata con le modifiche attuali la stampa dei PDF dei grafici piezometrici con la media</p>
            <p>FIX: Nella stampa dei PDF dei piezometri e dei packer è stata rimossa la scritta legenda che risultava priva di significato</p>
            <p>FIX: Corretta la profondità nel titolo dei grafici dei campioni rilevati</p>
            <p>FIX: Messa l'unità di misura dei gradi al posto della scritta gradi dove necessario</p>
            <p>FIX: Modifiche varie al PDF dei campioni rilevati</p>
            <p>FIX: Corretta la descrizione delle ore degli eventi accorpati nel PDF della cronologia degli eventi</p>
            <p>FIX: Reso più leggibile il PDF delle ampiezze degli eventi accelerometrici e quello della cronologia degli eventi accelerometrici</p>
            <p>FIX: La legenda dei sensori nella stampa PFD degli spostamenti sovrapposti adesso è più leggibile</p>
            <p>FIX: Gestiti meglio gli spazi nel PFD degli spostamenti sovrapposti</p>
            <p>FIX: Nei grafici degli spostamenti separati è stato corretto il calcolo della profondità del modulo</p>
            <p>FIX: Allineata la labal dell'allineamento con la versione desktop della stampa PDF dei grafici dello spostamento separato</p>
            <p>FIX: Aggiornata la scritta "spostamenti" in "spostamento" nella stampa PDF dei grafici dello spostamento separato</p>
            <p>FIX: Migliorata la grafica della stampa PDF dei grafici dello spostamento separato</p>
            <p>FIX: Corretto il calcolo della profondità nella stampa PDF dei grafici dello spostamento separato, velocità ed accelerazione</p>
            <p>FIX: Corretta la distanza in cui vengono scritte date ed ora nella asse X dei grafici</p>
            <p>FIX: I grafici di  assorbimento, tensione di alimentazione, velocità ed accelerazione sono stati resi più leggibili</p>
            <p>FIX: Adesso le falde dei PDF degli spostamenti vengono nuovamente stampate</p>
            <p>FIX: La label delle falde adesso è allineata correttamente nella stampa dei PDF, mentre prima si sovrapponeava al grafico</p>
            <p>FIX: Corretto il bug che non mostrava il numero del modulo nella stampa pdf</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.9.54</b>
          </div>
          <div class="col-md-3">
              09 Gennaio 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Corretta ed allineata all'EW la modalità di selezione dei moduli nel popup degli storici</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.9.53</b>
          </div>
          <div class="col-md-3">
              08 Gennaio 2026 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Corretto il bug che non faceva comparire un linea accanto alle informazioni generali durante il caricamente dell'aggiunta di un grafico abbinato</p>
            <p>FIX: Adesso gli hint del dettaglio del grafico di deformazione vengono visualizzati correttamente</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.9.52</b>
          </div>
          <div class="col-md-3">
              15 Dicembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>FIX: Corretto il bug che non facedva comparire i grafici piezometri che non mostravano la media</p>
            <p>FIX: La dimensione della label X adesso quando un grafico viene ingrandito non diventa più gigante</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.9.51</b>
          </div>
          <div class="col-md-3">
              15 Dicembre 2025 - Alessio Verardo, Andrea Capozza
          </div>
          <div class="col-md-6">
            <strong>Alessio Verardo</strong>
            <p>NEW: Nei grafici dei piezometri semplici ora è possibile visualizzare i valori dei grafici abbinati. Il numero massimo di colonne piezometriche visualizzabili nel grafico è 4</p>
            <p>CHG: Quando si fa lo zoom dei polari, adesso il grafico non sborda più</p>
            <p>CHG: Aggiornata la grafica delle tabelle dei grafici ingranditi</p>
            <p>CHG: Adesso i grafici ingranditi dei packer hanno un flag cxhe permette di visualizzare gli abbinati</p>
            <strong>Andrea Capozza</strong>
            <p>NEW: Aggiunta la possibilità di impostare e visualizzare le soglie degli allarmi nei grafici storici relativi alla velocita' media giornaliera</p>
            <p>NEW: Adesso è possibile configurare il colore del legal footer nella dashboard dalle impostazioni dei siti</p>
            <p>NEW: Aggiunta la possibilità di cambiare il colore degli allarmi nella dashboard attraverso la modifica della grafica</p>
            <p>NEW: Aggiunta la possibilità di configurare gli allarmi desiderati per la visualizzazione o meno dell'allarme attivo in dashboard</p>
            <p>CHG: Centrato l'allineamento verticale del popup e della tabella dei grafici abbinati</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.9.50</b>
          </div>
          <div class="col-md-3">
              05 Dicembre 2025 - Alessio Verardo, Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Alessio Verardo</strong>
            <p>FIX: Risolto bug che non mostrava il valore 0 sull'asse Y quando si ingrandiva il grafico dei piezometri</p>
            <p>FIX: Risolto bug che non mostrava correttamente l'allineamento dei triangoli markup nei grafici dei piezometri con packer</p>
            <strong>Dario Scianna</strong>
            <p>CHG: Per i grafici più profondi di 80 m, adesso la scala del notch utilizza multipli di 10 invece che di 5</p>
            <p>FIX: Ora quando si ingrandisce un grafico totale per lo spostamento orientato, mostra il grafico correttamente orientato, invece del totale</p>
            <p>FIX: Corretto il tokn della pagina successiva nella dashboard</p>
            <p>FIX: Aggiustato il dimensionamento dei grafici</p>
            <p>FIX: Modificata imagine default bianca dei siti che era troppo grossa e vada problemi di dimensionamento</p>
            <p>FIX: Adesso la label laterale dello spostamento nord dei polari nella dashboard ingrandisce correttamente di font con lo Zoom</p>
            <p>FIX: Corretti i token della profondità ed inserito l'accento</p>
            <p>FIX: La sezione del Riallineamento alla data nel grafici modulabili adesso è visualizzata al centro dello spazio disponibile</p>
            <p>DEL: Rimosso il triangolo lampeggiante per le catene in allarme</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.9.49</b>
          </div>
          <div class="col-md-3">
              04 Dicembre 2025 - Dario Scianna, Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>CHG: I menù dei grafici storici ora non vanno sopra al grafico quando la dimensione della finestra è più piccola</p>
            <p>CHG: I grafici storici dei capioni rilevati, spostamenti, velocità ed accelerazione adesso prendono anche la parte sinistra della pagina non lasciandola vuota</p>
            <p>FIX: Adesso i segmenti delle velocità vengono disegnati anche utilizzando anche altri browser oltre a Firefox come google Chrome ed Edge</p>
            <p>FIX: Spostata a sinistra la scritta del copyright della dashboard</p>
            <p>FIX: Nel menù laterale dei grafici storici è stata aggiornata la label "Allinea le assi" con "Allineamento assi"</p>
            <p>FIX: Ingrandita icona CSG nella dashboard</p>
            <p>FIX: Adesso le voci dei menù nella dashboard mostrano le scritte corrette, quando si entra e si esce dalla pagina non rimane la vecchia label erroneamente</p>
            <p>FIX: Adesso è gestito il ridimensionamento della pagine in cui sono presenti gli attuali, non sovrapponendo più i vari elementi fra di loro</p>
            <strong>Alessio Verardo</strong>
            <p>FIX: Adesso nel grafico delle deformazioni i valori sull'asse X sono espressi in centesimi ed è presente la suddivisione della scala sull'asse X</p>
            <p>FIX: Il valore massimo della deformazione adesso è sempre arrotondato per eccesso all'unità successiva, mentre il valore minimo se è 0 o positivo adesso viene mostrato con il valore 0 e non -1 mostrando il grafico spostato a destra</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.9.48</b>
          </div>
          <div class="col-md-3">
              04 Dicembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>CHG: Ridotta la dimensione della scritta del copyright</p>
            <p>CHG: Ridotta del 50% la dimensione del logo CSG vicino al copyright</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.9.47</b>
          </div>
          <div class="col-md-3">
              04 Dicembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>NEW: Aggiunta la possibilità di poter vedere il grafico in una determinato orientamento nei grafici totali dei modulabili</p>
            <p>CHG: Aggiornata l'icona del copyright cliccabile nella dashboard e nei modulabili con quella CSG</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.9.46</b>
          </div>
          <div class="col-md-3">
              03 Dicembre 2025 - Andrea Capozza, Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Andrea Capozza</strong>
            <p>CHG: Cambiato il label dell'asse Y nei grafici storici dello spostamento della velocità media giornaliera con mm/giorno</p>
            <p>CHG: I bottoni Aggiungi/Applica nella modifica modello dell'amministratore adesso hanno le stesse dimensioni degli altri</p>
            <strong>Alessio Verardo</strong>
            <p>CHG: Ridotta la dimensione delle scritte degli assi cartesiani nei grafici storici dei campioni rilevati</p>
            <p>CHG: Ridotta l'area dei pulsanti per dare più spazio ai grafici storici</p>
            <p>CHG: Ridotta la dimensione dei pulsanti e delle scritte nei grafici storici e rimosso il riquadro nero di contorno e il grassetto delle scritte</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.9.45</b>
          </div>
          <div class="col-md-3">
              02 Dicembre 2025 - Alessio Verardo, Andrea Capozza, Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Alessio Verardo</strong>
              <p>NEW: Nel popup delle velocità dei grafici degli spostamenti separati negli storici è stato aggiunto il pulsante "Aggiungi un segmento" a lato insieme agli altri che aggiunge un singolo segmento per volta e tolti i punsanti</p>
              <p>NEW: I nuovi segmenti creati nel popup delle velocità dei grafici degli spostamenti separati negli storici vengono nominati in automatico con valori progressivi e posizionati al di sotto del precedente nella tabella</p>
              <p>CHG: Sostituita l'icona per poter disegnare la velocità sul grafico negli storici degli spostamenti separati con un mirino al posto del pennello</p>
              <p>CHG: Il numero di elementi visualizzati nella tabella dei segmenti delle velocità negli spostamenti separati degli storici ora è 5 per pagina invece di 40</p>
              <p>CHG: Ridotta maggiormente la dimensione della finestra popup della scelta dei segmenti di velocità negli spostamenti separati degli storici, riducendo larghezza pulsanti e dimensione scritte</p>
              <p>CHG: Al doppio click, adesso vengono compilati con la data del giorno anche tutti i campi che hanno ore, minuti e secondi, mentre prima lo faceva solo con i campi che avevano unicamente la data</p>
              <p>CHG: La finestra di selezione dei segmenti di velocità dei grafici degli spostamenti separati negli storici è ora mobile e si può spostare per vedere i grafici sottostanti</p>
              <p>CHG: Rimpicciolita la scritta Spostamento sull'asse Y del grafico spostamenti</p>
              <p>CHG: Negli spostamenti storici è stata ridotta la dimensione dei pulsanti, delle voci delle legende, dei menù delle falde ed è stato tolto il carattere grassetto</p>
              <p>DEL: Rimosso il riquadro cerca e il pulsante Aggiungi verde (la funzionalità è ora nel pulsante "Aggiungi segmento") dalla tabella del popup delle velocità dei grafici degli spostamenti separati negli storici</p>
              <p>DEL: Rimosso il riquadro nero intorno ai pulsanti e alle scritte nella sezione spostamenti storici </p>
              <p>DEL: Rimossi i pulsanti '+' e '-' vicino ai menu a discesa per la scelta dei piezometri nella sezione spostamenti storici</p>
              <strong>Andrea Capozza</strong>
              <p>NEW: Aggiunto legal footer al login, alla dashboard ed ai grafici modulabili</p>
              <p>NEW: Aggiunto il popup dei dati di assistenza  alla dashboard ed ai grafici modulabili</p>
              <p>CHG: Aggiornato il vecchio logo con quello bianco nella login</p>
              <p>CHG: Aggiornato con il colore bianco lo sfondo nella login</p>
              <p>CHG: Aggiunto l'accento a velocita' in tutti i token</p>
              <p>CHG: Aggiornato il token per l'accelerazione oraria in mm/h2</p>
              <p>FIX: Adesso le label a sinistra non cambiano posizione dopo l'aggiunta di una falda nei grafici storici</p>
              <strong>Dario Scianna</strong>
              <p>CHG: Aggiornato il token per l'accelerazione giornaliera in mm/giorno2</p>
              <p>NEW: Adesso le voci Informazioni generali, Riallineamento alla data e Grafici abbinati, nella gestione delle bande modulabili, hanno la larghezza modificabile</p>
              <p>CHG: Le icone in basso a destra della dashboard adesso sono state messe nel menù in alto a destra a scomparsa</p>
              <p>CHG: Aggiornati i colori del menù a tendica come segue: 1° livello: R 241, G 139, B 83
                                                                         2° livello: R 243, G 153, B 104
                                                                         3° livello: R 244, G 165, B 123</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.9.44</b>
          </div>
          <div class="col-md-3">
              01 Dicembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>NEW: Adesso lo sfondo della scritta della data di abbinamento dei grafici in dashboard è configurabile dalle impostazioni dei siti</p>
            <p>NEW: Aggiunta la colonna "Livello [m pc]" ai grafici ingranditi dei piezometri</p>
            <p>CHG: Colorata di nero, rimpicciolita ed aggiunta la dicitura "Dati riferiti al: " nella data dei grafici ingranditi</p>
            <p>CHG: Adesso le scritte dei nomi dei grafici nei modulabili sono al centro della label, inoltre è stata leggermente ridotta di dimensioni</p>
            <p>FIX: Adesso nel menù la voce dashboard non si vede più quando si è nella dashboard</p>
            <p>FIX: Adesso la pressione nei piezometri ingranditi viene calcolata correttamente</p>
          </div>
          <br>
        </div> 
        
        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.43</b>
          </div>
          <div class="col-md-3">
              28 Novembre 2025 - Dario Scianna, Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>FIX: Adesso gli allarmi con valore 0 non vengono più erroneamente mostrati</p>
              <p>FIX: Aggiustata la visualizzazione della scrita degli allarmi nella dashboard</p>
            <strong>Alessio Verardo</strong>
              <p>CHG: Inserito lo scrolling verticale nei risultati dei grafici abbinati se vengono visualizzate più di 3 risultati</p>
              <p>CHG: Cambiata la disposizione dei dati sul Menu delle informazioni generali mettendoli come richiesto nel PDF in linea</p>
              <p>CHG: Inserito il cursore con la manina quando si passa sopra agli elementi dei grafici abbinati</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.9.42</b>
          </div>
          <div class="col-md-3">
              24 Novembre 2025 - Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Francesco Ardini</strong>
            <p>FIX: Cambiata la grafica dei menù laterali</p>
            <p>FIX: Adesso quando abbini un grafico nella dashboard e cambi sito, non rimane l'allineamento precedentemente messo</p>
            <p>FIX: La scritta laterale vicino ai placeholder ora è correttamente spostata</p>
            <p>FIX: La scritta di allineamento della dashboard ora ha un font più piccolo</p>
            <p>FIX: Il menù non rimane più aperto tra una schermata ed un altra</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.9.41</b>
          </div>
          <div class="col-md-3">
              24 Novembre 2025 - Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Francesco Ardini</strong>
            <p>CHG: Disabilitati i pulsanti di inserimento allineamento e rimozione allineamento alla data, nel caso non siano selezionate date da mostrare</p>
            <p>FIX: Risolto problema visualizzazione abbinati</p>
          </div>
          <br>
        </div> 
        
        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.40</b>
          </div>
          <div class="col-md-3">
              24 Novembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>CHG: Aggiornati i colori: Arancione da #ff734d ad #F18B53 (R 241, G 139, B 83), marrone da #60604d ad #7B6A58 (R 123, G 106, B 88)</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.39</b>
          </div>
          <div class="col-md-3">
              24 Novembre 2025 - Dario Scianna, Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>CHG: Aggiornati i colori: Arancione da #ff734d ad #F18B53 (R 241, G 139, B 83), marrone da #60604d ad #7B6A58 (R 123, G 106, B 88)</p>
            <p>FIX: Corrette le proporzioni della tabella degli abbinati nei modulabili</p>
            <strong>Alessio Verardo</strong>
            <p>FIX: La colonna d'acqua dei piezometri adesso non vieen disegnata più volte con gli abbinati coprendo il simbolo</p>
            <p>FIX: Corretto il bug che faceva disegnare le linee del simbolo dei piezometri in maniera non corretta</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.38</b>
          </div>
          <div class="col-md-3">
              21 Novembre 2025 - Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Alessio Verardo</strong>
            <p>CHG: Quando ingrandisco i packer, se sono presenti valori oltre lo zero adesso vengono visualizzati e le righe arrivano all'altezza reale</p>
            <p>CHG: Aggiornata stampa PDF dei grafici del piezometro con Packer con le stesse impostazioni della visualizzazione</p>
            <p>FIX: Aggiustati spazi dei valori nella colonna del grafico del piezometro standard</p>
          </div>
          <br>
        </div> 
        
        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.37</b>
          </div>
          <div class="col-md-3">
              21 Novembre 2025 - Dario Scianna, Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>CHG: Modificata la grafica della visualizzazione dei moduli per il popup degli storici per spostamento, velocità, accelerazione, campioni rilevati, assorbimento e tensione alimentazione</p>
            <p>CHG: Aggiornati i charset dei Content-Type da ISO-8859-15 a UTF-8</p>
            <p>CHG: Fatto sparire l'alone sotto all'hamburger del menu a tendina laterale</p>
            <p>CHG: Accorciato il popup di assorbimento e tensione alimentazione</p>
            <strong>Francesco Ardini</strong>
            <p>NEW: Adesso è possibile vedere l'ultimo allarme in dashboard grazie ad un bottone in basso a destra</p>
            <p>NEW: Adesso è possibile configurare il grassetto delle scritte</p>
            <p>CHG: Nei polari della dashboard adesso la scritta del polare dello spostamento nord viene scritta dal basso verso l'alto</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.36</b>
          </div>
          <div class="col-md-3">
              21 Novembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>CHG: Nella finestra dei grafici adesso i polari hanno il contorno</p>
            <p>CHG: Adesso nella dashboard per i siti in allarme lampeggia solo il triangolo</p>
            <p>CHG: Per distinguere la configurazione del colore tra stato di allarme e non nella dashboard, è stato impostato a verde il colore del sito</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.35</b>
          </div>
          <div class="col-md-3">
              20 Novembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>CHG: Update grafiche nella pagina dei grafici modulabili: - Informazioni generali è stata ridotta dal 20% della dimensione della pagina al 13%
                                                                         - Riallineamento alla data è stata ridotta dal 25% della dimensione della pagina al 15%
                                                                         - Grafici abbinati è stata ridotta dal 30% della dimensione della pagina al 15%
            </p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.34</b>
          </div>
          <div class="col-md-3">
              20 Novembre 2025 - Dario Scianna, Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>NEW: Adesso l'autoscale imposta le dimensioni del grafico basandosi sullo spostamento massimo dei suoi dati, 
                    non in base allo spostamento massimo configurato manualmente di tutti i grafici</p>
            <p>NEW: Adesso è possibile aprire le immagini delle catene, se presenti, con un doppio click</p>
            <p>CHG: Riabilitato il codice commentato per l'automatizzazione della scala dei polari, con check di configurazione per l'autoscale</p>
            <p>CHG: Resa più chiara l'icona in ogni polare che serve per forzare la dimensione di tutti i grafici con la sua</p>
            <p>CHG: Nel riallineamento alla data della finestra dei grafici è stata modificata la dicitura Modifica con Inserisci</p>
            <p>CHG: Nei grafici abbinati della finestra dei grafici è stata modificata la scritta Rinfresco automatico con Refresh automatico</p>
            <p>CHG: Nella finestra dei grafici sono state scambiate di posto data ultimo campione e riallineamento data</p>
            <p>CHG: Modificata l'immagine di default delle catene con un immagine bianca al posto di quella vecchia con il modulo</p>
            <p>FIX: Utilizato algoritmo per la suddivisione del grafico nei polari della dashboard</p>
            <p>FIX: Corretto l'algoritmo per la suddivisione dei grafici che non divideva correttamente i notch delle assi</p>
            <p>FIX: Corretto l'errore di caricamento dei grafici storici nella pagina dei grafici modulabili</p>
            <strong>Alessio Verardo</strong>
            <p>CHG: Sostituito il simbolo del triangolo con il simbolo delle 4 linee</p>
            <p>CHG: Spostata più a sinistra la colonna piezometrica e le scritte</p>
            <p>FIX: Adattata la dimensione del font per i piezometri semplici quando si visualizza il dettaglio</p>
            <p>CHG: Sostituito Prof. [m] con Profondita sensore</p>
            <p>CHG: Inserito il segno + per i valori positivi</p>
          </div>
          <br>
        </div> 
        
        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.33</b>
          </div>
          <div class="col-md-3">
              18 Novembre 2025 - Dario Scianna, Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
            <p>NEW: Aggiunta, a sinistra del logo DMS, l'icona dei tre trattini orizzontali per espandere e compattare il menù laterale</p>
            <p>CHG: Aggiornati i colori dei grafici che vengono creati di default con i colori bianchi e lo sfondo trasparente</p>
            <p>CHG: Aggiornate le scritte vicino ai polari con Spost. E [mm] e Spost. N [mm]</p>
            <strong>Alessio Verardo</strong>
            <p>CHG: La distribuzione delle righe verticali di quota dei packer adesso è distribuita a seconda dello spazio libero</p>
            <p>CHG: Le quote e le linee veticale della quota adesso sono blu</p>
            <p>CHG: Spostato kPa a capo sotto la pressione</p>
            <p>CHG: Impostato il colore della descrizione dei packer fucsia ed allineata al centro</p>
            <p>CHG: Sostituito m.p.c. con m pc nei packer</p>
            <p>CHG: Sostituito m H2O con kPa nel dettaglio dei packer</p>
            <p>DEL: Eliminata la quota dei dei packer a lato</p>
          </div>
          <br>
        </div> 
        
        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.32</b>
          </div>
          <div class="col-md-3">
              18 Novembre 2025 - Alessio Verardo
          </div>
          <div class="col-md-6">
            <strong>Alessio Verardo</strong>
            <p>NEW: Allineati i graficidei packer e dei piezometri con gli altri grafici</p>
            <p>NEW: Inserita banda azzurro pastello chiaro per indicare la falda nei grafici dei Piezometri</p>
            <p>NEW: Inserita griglia orizzontale per indicare la profondità nei grafici dei Piezometri</p>
            <p>CHG: Sostituito simbolo triangolo con 4 linee decrescenti nei grafici dei Piezometri</p>
            <p>CHG: Sostituito m.p.c. con m pc nei piezometri</p>
            <p>CHG: Inserite le stesse modifiche grafiche anche nella stampa PDF dei piezometri</p>
            <p>DEL: Eliminate le due linee orizzontali indicanti il livello m pc del piezometro</p>
          </div>
          <br>
        </div> 
        
        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.31</b>
          </div>
          <div class="col-md-3">
              18 Novembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>CHG: Il logo è stato aggiornato con quello bianco</p>
              <p>FIX: Nella modifica dei grafici per tutte le catene, non veniva carricato correttamente il dato per lo spostamento max</p>
              <p>FIX: Spostata a sinistra la grafica per la pagine dell'inserimento dei nuovi utenti</p>
              <p>FIX: La sezione per creare nuovi utenti non da più errore quando si entra nella pagina</p>
              <p>FIX: L'aggiornamento per le lingue adesso è visibile solo all'amministratore</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.30</b>
          </div>
          <div class="col-md-3">
              17 Novembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>NEW: Nella dialog di selezione della data di allineamento della dashboard sono stati inserite le selezione ultime 24 ore, ultima settimana, ultimo mese, dalla data precisa</p>
              <p>NEW: Nella dashboard è stato inserito un bottone per poter aggiornare tutti i colori dei grafici contemporaneamente</p>
              <p>CHG: Nella finestra dei grafici i tasti di allineamento sono stati aggiornati 24h, 48h, 1 sett., Altro</p>
              <p>FIX: Adesso quando modifico la grafica di tutte le catene, viene caricata la configurazione della prima catena casuale</p>
              <p>FIX: Corretta la modifica grafici per tutte le catene che non aggiornava tutti i valori correttamente</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.29</b>
          </div>
          <div class="col-md-3">
              14 Novembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>CHG: Adesso il nome del sito non è più scritto sopra l'immagine, me è stato spostato nell'header in alto al centro</p>
              <p>CHG: Nei polari della dashboarda è stata inserita la dicitura: "Dati dal data_installazione/calibrazione" se il campione non è allineato</p>
              <p>CHG: Nei polari della dashboarda è stata sostituita la stringa "Grafico relativo alla data" con  "a data campione" se non è allineato, altrimenti con "Data campione"</p>
              <p>CHG: Nella dashboarda la data di allineamento essendo una per tutte, adesso invece che essere scritta dentro i grafici, compare in un box in alto a destra</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.28</b>
          </div>
          <div class="col-md-3">
              31 Ottobre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>CHG: Adesso nei siti hanno solo le stazioni meteo, non visualizzano i polari</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.27</b>
          </div>
          <div class="col-md-3">
              31 Ottobre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>CHG: Nei grafici della stazione meteo, quando la pioggia riparte da zero, adesso il grafico viene interrotto</p>
              <p>FIX: Nel dettaglio ingrandito del piezometro, adesso di vedono le altezze sopra il piano campagna quando escono sopra dal grafico e non vengono più tagliate</p>
              <p>FIX: Quando nella stazione meteo vengono resi non visibili tutti i campi dell'asse X, adesso sparisce correttamente anche l'ultimo grafico</p>
              <p>FIX: Quando veniva rimosso un grafico abbinto, ne veniva rimosso uno sbagliato</p>
              <p>FIX: Aggiornati i colori del grafico della stazione meteo</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.26</b>
          </div>
          <div class="col-md-3">
              31 Ottobre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>FIX: Adesso le modifiche delle impostazioni ai grafici avvengono correttamente. Prima veniva ricaricata la pagina prima che il server facesse la post</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.25</b>
          </div>
          <div class="col-md-3">
              20 Ottobre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>NEW: Inserita la voce nel menù per gli allarmi</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.8.24</b>
          </div>
          <div class="col-md-3">
              13 Ottobre 2025 - Federico Migliazzi
          </div>
          <div class="col-md-6">
            <strong>Federico Migliazzi</strong>
              <p>NEW: ricevimento automatico file cew</p>
          </div>
          <br>
        </div> 
        
        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.7.24</b>
          </div>
          <div class="col-md-3">
              08 Ottobre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>FIX: Risolto il problema per cui non venivano visualizzati i segmenti della velocità negli spostamenti totali</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.7.23</b>
          </div>
          <div class="col-md-3">
              23 Settembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>FIX: Corretta la query che conta il numero di accelerometri ed inclinometri</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.7.22</b>
          </div>
          <div class="col-md-3">
              19 Settembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>CHG: Adesso non verranno più visualizzati gli inclinometri nei campioni rilevatiquando vengono caricati solo estensimetri o solo piezometri</p>
              <p>CHG: Adesso non si può più confermare il popup per i grafici storici di spostamento, velocità ed accelerazione quando si selezionano un piezometro oppure un estensimetro</p>
              <p>CHG: Adesso viene disabilitato l'inserimento dell'orientamento nord nel popup per i grafici storici di spostamento, velocità ed accelerazione quando si selezionano un piezometro oppure un estensimetro</p>
              <p>CHG: Selezionando "Tutti" nel popup degli storici per spoostmaneto, velocità ed accelerazione è possibile inserire comunque l'orientamento dell'asse nord</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.7.21</b>
          </div>
          <div class="col-md-3">
              26 Settembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>CHG: Quando viene caricato il grafico della stazione meteo per le catene senza inclinometro, adesso l'intervallo temporale dei dati caricati è di 30 giorni come richiesto</p>
              <p>CHG: Sono state cambiate le scale di misura della pioggia dieci minuti per allinearle all'EW</p>
              <p>FIX: Corretta la legenda del colore per la stampa del grafico dieci minuti pioggia</p>
              <p>FIX: Adesso il colore del grafico della pioggia10 minuti viene disegnato del colore corretto e non segue il colore della falda</p>
              <p>FIX: Risolto avviso di deprecazione per la proprietà dinamica MostraSingoloTotale in TStazioneMeteo</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.7.20</b>
          </div>
          <div class="col-md-3">
              15 Settembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>CHG: La pioggia 10 min adesso è sempre visibile nella stazione meteo</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.7.19</b>
          </div>
          <div class="col-md-3">
              11 Settembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>CHG: Aumentato lo spessore del grafico del cumulativo pioggia</p>
              <p>FIX: Corretti i nomi delle variabili nella funzione FGetGruppoDieciMinuti per la stampa della stazione meteo che causavano errori di riferimento e metodo</p>
              <p>FIX: Corretta la rappresentazione della pioggia cumulata nei pdf</p>
              <p>FIX: Corretto il calcolo della pioggia nella stampa del pdf della stazione meteo</p>
              <p>FIX: Corretto il modo in cui viene calcolata la pioggia cumulata nella stampa del pdf della stazione meteo</p>
              <p>FIX: Corretto il modo in cui viene visualizzato il cumulativo pioggia. 
                      Adesso la pioggia non si accumula più all'infinito, se non ha dati validi per più di 20 min si "interrompe" come in EW</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.7.18</b>
          </div>
          <div class="col-md-3">
              10 Settembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>CHG: Per i grafici senza inclinometri, la pioggia ogni 10 minuti adesso è sempre visibile</p>
              <p>CHG: Il grafico della stazione meteo di giornaliero pioggia adesso non viene disegnato più sopra gli altri grafici</p>
              <p>FIX: Corretto il bug che creava pagine bianche nella stampa pdf degli attuali</p>
              <p>FIX: Risolto il bug che faceva scomparire negli storici dei moduli scambiandoli per moduli di input-output</p>
          </div>
          <br>
        </div>

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.7.17</b>
          </div>
          <div class="col-md-3">
              08 Settembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>NEW: Creata la nuova costante SPESSORE_LINEE_GRAFICI per modificare lo spessore delle linee dei grafici</p>
              <p>CHG: I colori delle falde sono stati aggiornati con tonalità comprese tra il blu e l'azzurro</p>
              <p>CHG: Rimosso lo zoom per i grafici di profilo longitudinale, deformazione longitudinale e rispettivi grafici allineati</p>
              <p>CHG: Sono stati aggiornati i colori del grafico della stazione meteo</p>
              <p>CHG: Adesso le righe vuote delle tabelle delle stampe degli attuali non vengono più visualizzate</p>
              <p>FIX: Adesso apre correttamente direttamente la stazione meteo quando una catena non ha altri grafici</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.7.16</b>
          </div>
          <div class="col-md-3">
              05 Settembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>FIX: I grafici del Profilo longitudinale venivano cancellati quando si faceva lo zoom in una parte del grafico senza valori negativi</p>
              <p>FIX: Adesso l'asse X dei grafici di deformazione ha come intervallo fisso da -1 ad 1 come su EW ed un udm di 0.2</p>
              <p>CHE: Adesso lo zoom nei grafici con profilo longitudinale è prevalentemente alto invece che centrato</p>
            <strong>Francesco Ardini</strong>
              <p>FIX: non compare più il modulo di input-output per gli storici</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.7.15</b>
          </div>
          <div class="col-md-3">
              04 Settembre 2025 - Dario Scianna
          </div>
          <div class="col-md-6">
            <strong>Dario Scianna</strong>
              <p>NEW: Aggiunta la costante COLORI_FALDE per poter gestire il colore delle falde</p>
              <p>FIX: Adesso i campioni rilevati vengono visualizzati correttamente</p>
              <p>FIX: Nell'asse spostamento Nord adesso viene accettato anche il valore 0</p>
              <p>FIX: Importato allow origin in alcuni punti del codice in cui mancava</p>
              <p>FIX: Gli intervalli dell'asse X adesso sono ogni 6 ore quando si prende l'intervallo di date suggerito, come in EW</p>
              <p>FIX: Adesso la scala dell'asse X dei grafici di deformazione è visibile anche quando sono presenti piccoli movimenti</p>
              <p>FIX: L'asse X dei grafici di deformazione ora mostra un decimale</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.7.14</b>
          </div>
          <div class="col-md-3">
              03 Settembre 2025 - Francesco Ardini e Dario Scianna
          </div>
          <div class="col-md-6">
            <p>NEW: Inserito il filtro per Piezometri ed estensimetri nel popup dello spostamento, della velocità e dell'accelerazione</p>
            <p>NEW: Gestita l'esportazione degli excel dei dati storici</p>
            <p>NEW: I siti che non hanno pluviometri legati alla colonna adesso vanno direttamente alla pagina dei grafici meteo;</p>
            <p>CHG: Rimosso il valore di default 0 per l'orientamento asse dell'asse nord nel popup dello spostamento, della velocità e dell'accelerazione</p>
            <p>CHG: Introdotta la costante ALLOW_ORIGIN che viene utilizzata nei file php per gestire Access-Control-Allow-Origin</p>
            <p>CHG: Nel titolo viene ora aggiunto "- cum." se il grafico è cumulato</p>
            <p>CHG: Modificato il menu riunendo esportazione pdf ed xml sotto un'unico pulsante</p>
            <p>FIX: Corretto il bug che fa scomparire i grafici attuali quando si mette un grafico abbinato nuovo e nascondendo il grafico attuale si elimina
                      il nuovo grafico abbinato inserito</p>                      
            <p>FIX: Corretto il caricamento dei moduli dei piezometri</p>        
            <p>FIX: Corretto il calcolo del notch per l'asse X</p>            
            <p>FIX: Nel dettaglio della deformazione, adesso viene mostrato un trattino nella deformazione di moduli che non sono estensimetri e non più il valore 0</p>
            <p>FIX: Sistemato problema con le etichette dei grafici meteo;</p>
            <p>FIX: Sistemate scale grafici meteo;</p>
            <p>FIX: Sistemata ricarica dei dati grafici meteo;</p>
            <p>FIX: Sistemati grafici meteo precipitazione oraria;</p>
            <p>FIX: Sistemata modifica udm X per grafici meteo;</p>
            <p>FIX: Adesso compaiono i giusti campioni per l'allineamento</p>
            <p>FIX: Non vengono più esportati i grafici di deformazione se la colonna non ha estensimetri</p>
            <p>FIX: Non vengono più esportati i dati estensimetrici nel file xlsx se la colonna non ha estensimetri</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.6.13</b>
          </div>
          <div class="col-md-3">
              22 Luglio 2025 - Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Francesco Ardini</strong>
              <p>FIX: Sistemata visualizzazione markup per gli storici</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.6.12</b>
          </div>
          <div class="col-md-3">
              22 Luglio 2025 - Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Francesco Ardini</strong>
              <p>FIX: Risolto problema fuso orario abbinati pagina modulabili</p>
              <p>FIX: Non vengono più visualizzati i punti che hanno temperatura non valida nel grafico attuale della temperatura</p>
              <p>FIX: Risolto problema fuso orario data di allineamento</p>
          </div>
          <br>
        </div> 

        <div class="col-md-12" style="background-color: #b3dbff;">
          <hr>
          <div class="col-md-3">
              <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.6.11</b>
          </div>
          <div class="col-md-3">
              21 Luglio 2025 - Francesco Ardini
          </div>
          <div class="col-md-6">
            <strong>Francesco Ardini</strong>
              <p>FIX: Corretto l'update della configurazione dei moduli</p>
          </div>
          <br>
        </div>

        <div class="col-md-12" style="background-color: #b3dbff;">
            <hr>
            <div class="col-md-3">
                <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.6.10</b>
            </div>
            <div class="col-md-3">
                11 Giugno 2025 - Dario Scianna
            </div>
            <div class="col-md-6">
              <strong>Dario Scianna</strong>
                <p>FIX: Corretta la gestione dei dati per la stampa</p>
                <p>FIX: Non viene scritta la label del modulo 0 quando creo un PDF di un grafico dei totali</p>
                <p>FIX: Adesso i grafici della lista superamento soglia vengono caricati correttamente</p>
            </div>
            <br>
        </div>

        <div class="col-md-12" style="background-color: #b3dbff;">
            <hr>
            <div class="col-md-3">
                <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.6.9</b>
            </div>
            <div class="col-md-3">
                28 Maggio 2025 - Dario Scianna
            </div>
            <div class="col-md-6">
              <strong>Dario Scianna</strong>
                <p>FIX: Le stampe degli eventi acceleromentrici (frequenza ed ampiezza) ora hanno la legenda corretta"</p>
                <p>CHG: Quando non sono presenti dati in una catena, adesso compare un div invece che l'errore "this.UltimaData is null[]"</p>
                <p>NEW: Introdotta la stampa dei grafici verticali (GV)"</p>
                <p>FIX: Nascondendo e mostrando i dati nel grafico dei piezometro ora non somma più le label"</p>
            </div>
            <br>
        </div>

        <div class="col-md-12" style="background-color: #b3dbff;">
            <hr>
            <div class="col-md-3">
                <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.6.8</b>
            </div>
            <div class="col-md-3">
                22 Maggio 2025 - Dario Scianna
            </div>
            <div class="col-md-6">
              <strong>Dario Scianna</strong>
                <p>FIX: Ora il PDF dei grafici della lista superamento soglia funziona correttamente</p>
                <p>FIX: Nei grafici delle ampiezze degli eventi accelerometrici, adesso l'adatta funziona correttamente</p>
                <p>FIX: I PDF della frequenza degli eventi accelerometrici adesso rispettano il fuso in cui vengono stampati</p>
                <p>FIX: I totali delle velocità orarie, adesso arrotondano correttamente le date dei dati se sono presenti più dati all'interno di un unica ora</p>
                <p>FIX: I PDF dei totali dei grafici giornalieri, adesso sono corretti anche se è presente il fuso orario</p>
                <p>FIX: I grafici della cronologia eventi accelerometrici adesso vengono di nuovo caricati correttamente</p>
                <p>FIX: Corretta l'intestazione della label dell'asse X dei PDF dei giornalieri e della frequenza degli eventi accelerometrici</p>
                <p>FIX: Le label di descrizione nel PDF degli Eventi accelerometrici superamento soglie ora sono tutte della stessa grandezza</p>
            </div>
            <br>
        </div>

        <div class="col-md-12" style="background-color: #b3dbff;">
            <hr>
            <div class="col-md-3">
                <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.6.7</b>
            </div>
            <div class="col-md-3">
                19 Maggio 2025 - Dario Scianna
            </div>
            <div class="col-md-6">
              <strong>Dario Scianna</strong>
                <p>FIX: Adesso l'hint dei grafici non si accavalla più e mostra correttamente tutto l'hint</p>
                <p>FIX: Nella cronologia degli eventi accelerometrici, quando la profondità è minore o uguale a 20, adesso il notch è 2 invece che 10</p>
                <p>FIX: Adesso anche i totali della velocità dell'accelerazione vengono correttamente segnati alle 12 nei grafici</p>
                <p>FIX: Sistemati i problemi che impedivano ai grafici delle accelerazione e delle velocità, sia giornalieri che orari, di essere corretti</p>
                <p>FIX: Corretti i calcoli degli spostamenti totali</p>
                <p>FIX: Corretto il fuso dei dati caricati su php che usava un fuso non corretto</p>
                <p>FIX: Ora entra correttamente nei grafici verticali quando entro nella catena dal pallino rosso, mentre prima entrava ancora nel componente dei grafici vedrticali vecchio</p>
                <p>FIX: Ora l'hint dei piezometri si vede nuovamente</p>
                <p>NEW: Inseriti i pulsanti per la stampa dei grafici storici nella pagine dei modelli dei grafici verticali</p>
                <p>NEW: Ora le stampe dei PDF vengono gestite tutte in un unico file php</p>
                <p>FIX: La legenda adesso funziona correttamente</p>
                <p>FIX: I colori dei grafici cambiano correttamente con quelli scelti nei grafici modulabili</p>
                <p>NEW: La stampa del sommario ora è gestita separatamente</p>
                <p>FIX: Ora la stampa dei singoli grafici nella pagine dei verticali modulabili funziona correttamente</p>
                <p>FIX: I grafici dei campioni rilevati, spostamenti separati e sovrapposti vengono stampati di nuovo correttamente</p>
                <p>FIX: Le stampe dei grafici delle velocità orarie e giornaliere e delle accelerazioni orarie e giornaliere funzionano di nuovo correttamente</p>
                <p>FIX: I grafici totali delle accelerazioni e velocità adesso vengono calcolati correttamente</p>
                <p>FIX: La stampa dei grafici di tensione alimentazione ed assorbimento funzionano di nuovo correttamente</p>
                <p>FIX: Le stampe dei grafici di dettaglio frequenza per modulo e dettaglio ampiezza XYZ per modulo funzionano di nuovo correttamente</p>
                <p>FIX: Risolto il delay di 1h nei PDF dei grafici totali</p>
                <p>FIX: Sistemata la stampa PDF dei grafici giornalieri</p>
                <p>FIX: L'ultimo punto dei grafici totali adesso è rappresentato correttamente</p>
                <p>FIX: Le stampe dei grafici della lista superamento soglia e cronologia eventi sono stati ripristinate</p>
                <p>FIX: Corretta la generazione del file Excel nella pagine dei grafici modulabili</p>
            </div>
            <br>
        </div>

        <div class="col-md-12" style="background-color: #b3dbff;">
            <hr>
            <div class="col-md-3">
                <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.6.6</b>
            </div>
            <div class="col-md-3">
                05 Maggio 2025 - Dario Scianna
            </div>
            <div class="col-md-6">
              <strong>Dario Scianna</strong>
                <p>FIX: Risolte differenze Udmx asse X dei grafici con EW nei campioni rilevati</p>
                <p>FIX: Sono stati corretti e gestiti singolarmente i calcoli della label x per i grafici di accelerazione giornaliera ed oraria, velocità giornaliera ed oraria, spost. separati e sovrapposti</p>
                <p>FIX: Corretto il calcolo delle velocità e delle accellerazioni che dava valori estremamente sbagliati sballati in una direzione</p>
                <p>FIX: Corretta la profondità delle label che dava un range sbagilato</p>
                <p>FIX: Corrette alcune descrizioni del popup dei modelli</p>
                <p>FIX: Adesso non viene resettato più il modello di default quando si salva oppure elimina un modello</p>
                <p>FIX: Risolto il problema per cui dava un errore quando si provava a cambiare il default da una catena senza un suo modello</p>
                <p>FIX: Adesso la lista di superamento soglia viene caricata correttamente</p>
                <p>FIX: Corretta la profondità nella label dei grafici degli eventi accelerometrici per il dettaglio frequenza per modulo</p>
                <p>FIX: Il bottone che filtra i grafici di 50 in 50 adesso funziona correttamente</p>
                <p>CHG: Spostata l'immagine di default delle catene nella cartella public</p>
                <p>FIX: Corretto il calcolo dei piezometri nei campioni rilevati</p>
                <p>FIX: Nel calcolo degli spostamenti e della stazione meteo, ora i primi due punti vengono calcolati corretamente</p>
                <p>CHG: Quando vengono presi i dati per grafici giornalieri ed orari, ora vengono presi più dati per il calcolo del grafico, rispettivamente 1 ora ed 1 giorno</p>
            </div>
            <br>
        </div>
        
        <div class="col-md-12" style="background-color: #b3dbff;">
            <hr>
            <div class="col-md-3">
                <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.5.5</b>
            </div>
            <div class="col-md-3">
                16 Aprile 2025 - Dario Scianna
            </div>
            <div class="col-md-6">
                    <strong>Dario Scianna</strong>
                    <p>FIX: Modificato il caricamento ed il salvataggio delle immagini per le catene</p>
            </div>
            <br>
        </div>

        <div class="col-md-12" style="background-color: #b3dbff;">
            <hr>
            <div class="col-md-3">
                <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.5.4</b>
            </div>
            <div class="col-md-3">
                15 Aprile 2025 - Dario Scianna, Mauro Brasile
            </div>
            <div class="col-md-6">
                    <strong>Dario Scianna</strong>
                    <p>NEW: Aggiunta configurazione report attuali</p>
                    <strong>Mauro Brasile</strong>
                    <p>NEW: Aggiunti grafici verticali ed orizzontali</p>
            </div>
            <br>
        </div>

        <div class="col-md-12" style="background-color: #b3dbff;">
            <hr>
            <div class="col-md-3">
                <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.4.4</b>
            </div>
            <div class="col-md-3">
                18 Marzo 2025 - Dario Scianna
            </div>
            <div class="col-md-6">
                    <strong>Dario Scianna</strong>
                    <p>NEW: Aggiunta gestione lingue</p>
                    <strong>Simone Biancolilla</strong>
                    <p>FIX: Ora i dati si possono nascondere solo nel grafico del piezometro e le scritte non si sdoppiano più</p>
                    <p>FIX: Il sito non si blocca più al caricamento se gli mancano le date</p>
                    <p>FIX: Sistemato il massimo dell'asse Y nei grafici storici, sia con i grafici normali che con i grafici adattati</p>
                    <p>FIX: Nella finestra di selezione della data di allineamento non si può più selezionare un orario non valido impostando una data, e successivamente cambiandola</p>
            </div>
            <br>
        </div>

        <div class="col-md-12" style="background-color: #b3dbff;">
            <hr>
            <div class="col-md-3">
                <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.3.4</b>
            </div>
            <div class="col-md-3">
                03 Marzo 2025 - Dario Scianna
            </div>
            <div class="col-md-6">              
                    <strong>Dario Scianna</strong>
                    <p>NEW: Inserita la griglia nel grafico dei piezometri</p>
                    <p>CHG: Rimpicciolite le scritte nel grafico dei piezometri</p>
                    <p>NEW: Quando il livello dei piezometri è al di sopra del piano campagna, viene comunque visualizzato</p>
                    <p>NEW: Inserito nel menù laterale la possibilità di occultare o mostrare i dati del piezometro in corrispondenza dei triangolini</p>
                    <p>NEW: Iserito l'hint che mostra i dati del grafico del piezometro quando vado sul markup o sul triangolo</p>
            </div>
            <br>
        </div>

        <div class="col-md-12" style="background-color: #b3dbff;">
            <hr>
            <div class="col-md-3">
                <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.3.4</b>
            </div>
            <div class="col-md-3">
                19 Febbraio 2025 - Mauro Brasile, Dario Scianna, Federico Migliazzi
            </div>
            <div class="col-md-6">              
               <p style="font-weight: bold;">Francesco Ardini</p>
               <p>FIX: Aggiunta gestione catena non trovata e sito non trovato nella SaveData.php</p>
               <p>FIX: Ripristinata scala verticale anche per il packer</p>
               <p style="font-weight: bold;">Federico Migliazzi</p>
               <p>CHG: Modifiche grafica datatable</p>
               <p style="font-weight: bold;">Dario Scianna</p>
               <p>FIX: Sistemati gli arrotondamenti delle tabelle di deformazione</p>
               <p>FIX: I font dei grafici piezometrico standard e con packer non cambiano più con lo zoom.</p>
               <p>FIX: La colonna del grafico piezometrico adesso è spostata a sinistra</p>
               <p>FIX: I grafici piezometrico e standard adesso sono più grandi nei verticali</p>
               <p>NEW: Introdotte le costanti GRAPH_SHIFT e TEXT_DIMENSION per modificare la posizione ed il testo del grafico piezometrico con packer</p>
               <p>NEW: Introdotte le costanti ENLARGE_GRAPHIC e TEXT_DIMENSION per modificare la grandezza della colonna ed il testo del grafico piezometrico standard</p>               <p>FIX: Sistemati gli arrotondamenti delle tabelle quando vengono caricate</p>
               <p>FIX: Nella tabella del dettaglio piezometrico ora sono presenti i valori di pressione</p>
               <p>FIX: Le label degli estensimetri e dei piezometri adesso non riportano più la scritta "Inclinazioni" ma "Estensioni" e "Piezometro"</p>
            </div>
            <br>
        </div>

        <div class="col-md-12" style="background-color: #b3dbff;">
            <hr>
            <div class="col-md-3">
                <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.3.3</b>
            </div>
            <div class="col-md-3">
                18 Febbraio 2025 - Mauro Brasile, Dario Scianna
            </div>
            <div class="col-md-6">              
               <p style="font-weight: bold;">Francesco Ardini</p>
               <p>FIX: Ripristinate scale verticali anche per piezometro;</p>
               <p>FIX: Adesso scompaiono i placeholder se viene eliminata una catena</p>
               <p>FIX: Sistemato problema fuso orario</p>
               <p>FIX: Label progetto errata</p>
               <p style="font-weight: bold;">Mauro Brasile</p>
               <p>NEW: Aggiunta gestione delle immagini verticali di un sito</p>
               <p style="font-weight: bold;">Federico Migliazzi</p>
               <p>CHG: ora i piezometri packer possono sbordare oltre il canvas e vengono generati in maniera inversa per evitare che le linee si incrocino</p>
               <p style="font-weight: bold;">Simone Biancolilla</p>
               <p>NEW: Aggiunto la possibilità di scegliere la direzione in cui far spuntare il titolo dei pallini nella dashboard</p>
               <p style="font-weight: bold;">Dario Scianna</p>
               <p>CHG: I dati nella tabella dei grafici ingranditi adesso sono allineati a destra</p>
               <p>FIX: Sistemati gli Hint nei campioni rilevati con markup</p>
               <p>NEW: Aggiunti gli Hint nei campioni rilevati con markup</p>
               <p>CHG: Case Insensitive quando carica chiave sito</p>
               <p>FIX: Risolto il bug per il quale non funzionavano più i segmenti velocità</p>
               <p>NEW: Ora è possibile inserire il segmento di velocità nel grafico degli spostamenti direttamente con il mouse sul grafico</p>
               <p>FIX: Sistemata la tabella del dettaglio che non veniva popolata correttamente</p>
               <p>CHG: Le scale degli dell'estensimetri (deformazioni [mm]) adesso sono in decimi come nell'EW</p>
               <p>NEW: Aggiunto il pulsante per adattare gli assi di tutti i grafici nei grafici storici e migliorata la grafica dei grafici storici</p>
               <p>CHG: Modificati alcuni titoli dei grafici storici: - Nei grafici degli eventi accelerometrici non mostra più i decimali se non necessario.
                                                                     - Nei grafici di spostamento quando indica la profondità adesso indica prima la profondità minore e successivamente la maggiore come su EW.
                                                                     - Nei grafici sovrapposti, adesso mostra la direzione di riferimento.
                                                                     - Nei grafici dei campioni rilevati adesso nostra il range della profondità e non solo la profondità massima.
              </p>
            </div>
            <br>
        </div>

        <div class="col-md-12" style="background-color: #b3dbff;">
            <hr>
            <div class="col-md-3">
                <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.2.2</b>
            </div>
            <div class="col-md-3">
                11 Febbraio 2025 - Migliazzi Federico
            </div>
            <div class="col-md-6">              
               <p style="font-weight: bold;">Federico Migliazzi</p>
               <p>NEW: Aggiunto bottone di refesh grafici automatico e inserito parametro modificabile per decidere ogni quanto deve avvenire</p>
               <p>NEW: Aggiunto utenti.TEMPO_AUTOREFRESH_DATI INT(3) Default '10' </p>
               <p>FIX: Bottone annulla in "modifica al profilo"</p>
               <p>FIX: Ora le lable in informazioni generali vanno a capo anche se la scritta è troppo lunga e non ha spazi</p>
               <p>NEW: aggiunta possibilità di andare alla prima e l'ultima pagina nel pager</p>
               <p>FIX: ora la selezione delle pagine è aggiornata dinamicamente</p>
               <p>FIX: ora la freccia nella paginazione compare correttamente anche quando siamo alla seconda e penultima scheda</p>
               <p>FIX: ora la freccia nella paginazione non è più bianca</p>
               <p style="font-weight: bold;">Simone Biancolilla</p>
               <p>FIX: Correzione carico CEW</p>
               <p>FIX: Tabella riepologativa che non scorre</p>
               <p>NEW: Nuova gestione piezometri in grafici di spostamento</p>
               <p style="font-weight: bold;">Chiara Russano</p>
               <p>CHG: Doppio click sulla data per impostarla al giorno odierno. Non ho usato la querySelectorAll, perchè su alcuni input non aveva effetto</p>
               <p>FIX: Piccole modifiche grafiche</p>
            </div>
            <br>
            <br>
        </div>
        <div class="col-md-12" style="background-color: #b3dbff;">
            <hr>
            <div class="col-md-3">
                <b style="color:#2596be; font-size: 20px; font:bold; margin-left:10px"> Versione 1.1.1</b>
            </div>
            <div class="col-md-3">
                05 Febbraio 2025 - Dario Scianna
            </div>
            <div class="col-md-6">              
              <p>NEW: Inserito il bottone della versione nella dashboard</p>
              <p>CHG: Allargato l'input per la data dei grafici abbinati</p>
              <p>CHG: Modificato il popup che appare per modificare le impostazioni degli assi x ed y nei grafici verticali</p>
              <p>CHG: Il grafico polare nei verticali è stato ingrandito</p>
              <p>CHG: La precisione dei decimali degli assi verticali adessi viene calcolata invece di essere fissa</p>
              <p>CHG: Sistemata la dimensione delle righe dei moduli nella finestra di selezione per i grafici</p>
              <p>CHG: Nei grafici ingranditi i decimali nell tabella ora sono fissi a seconda del dato rappresentato</p>
              <p>CHG: Messo lo stem nel popup dei grafici storici a 0,01</p>
              <p>CHG: Corretta dimensione pagina dei grafici verticali</p>            
              <p>CHG: Aggiornati i colori dei grafici da blue a navy nei grafici storici</p>
              <p>FIX: Il popup per modificare le impostazioni degli assi y non appare più per i polari</p>
              <p>CHG: Adesso, quando non sono presenti grafici abbinati, non si vede più la tabella. Inoltre è stata aggiornata la grafica della tabella</p>
              <p>NEW: Adesso è possibile cancellare i grafici abbinati anche dalla loro tabella</p>
              <p>CHG: Nella tabella dei grafici abbinati, adesso, quando aperta, visualizza di default la data attuale</p>
              <p>FIX: Corretto il bug per il quale, quando si cancellava un grafico abbinato senza il grafico recente visibile, compariva un errore</p>
              <p>CHG: Migliorata la grafica delle tabelle</p>
              <p>CHG: Aggiornata la grafica della finestra di selezione per i campioni rilevati</p>
              <p>CHG: Migliorati graficamente i popup di ricerca dei campioni</p>
            </div>
            <br>
            <br>
        </div>

       </div>
    </div>
</template>

<script>
export default 
{
  name  : "VUEVersioneDMSEW",
  props : ['Altezza'],
  data()
  {
  },

  methods :
  {

  }
}
</script>